import { render, staticRenderFns } from "./StepExtraOptions.vue?vue&type=template&id=247b07ba&scoped=true"
import script from "./StepExtraOptions.vue?vue&type=script&lang=js"
export * from "./StepExtraOptions.vue?vue&type=script&lang=js"
import style0 from "./StepExtraOptions.vue?vue&type=style&index=0&id=247b07ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247b07ba",
  null
  
)

export default component.exports